import { useState } from "react";
import { useEmailPerformanceReportState } from "../../../Reports/EmailPerformance/EmailPerformanceReportState";
import { EmailPerformanceReport } from "../../../Reports/EmailPerformance/EmailPerformance";
import { IndividualEmailPerformance } from "../../../Reports/EmailPerformance/IndividualEmailPerformance";
import DateRangePicker from "../../../App/Components/DateRange/DateRangePicker";
import { Grid } from "@mui/material";
import EmailMetricCards from "../../../Reports/EmailPerformance/EmailMetricsCards";

export default function EmailAnalytics({ groupId }: { groupId: string }) {
  const [startDate, setStartDate] = useState<Date>(new Date());

  const [endDate, setEndDate] = useState<Date>(new Date());

  const emailState = useEmailPerformanceReportState(startDate, endDate, groupId);

  return (
    <>
      <Grid container sx={{ mb: 3, mt: 3 }}>
        <Grid item md={6} lg={9}></Grid>
        <Grid item xs={12} md={6} lg={3}>
          <DateRangePicker
            id="group-email-report-dates"
            startDate={startDate}
            endDate={endDate}
            handleSetStartDate={(d) => {
              if (d) setStartDate(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0));
            }}
            handleSetEndDate={(d) => {
              if (d) setEndDate(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59));
            }}
          />
        </Grid>
      </Grid>
      <EmailMetricCards id="group" state={emailState} />
      <EmailPerformanceReport
        reportData={emailState.getters.reportData}
        enabled={true}
        id="group"
        loading={emailState.getters.isLoading}
      />
      <IndividualEmailPerformance groupId={groupId} startDate={startDate} endDate={endDate} />
    </>
  );
}
